import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  EnquiryThreeValidation,
  EnquiryFourValidation,
  EnquiryFiveValidation,
  EnquirysixValidation,
  EnquirySevenValidation,
  EnquiryEightValidation,
  EnquiryNineValidation,
  EnquiryTenValidation,
  EnquiryElevenValidation,
  customerPasswordSet,
  customerOtpSet,
  propertyTypeValidation,
} from "../utils/Validations";
import EnquiryThree from "./tellusSteps/EnquiryThree";
import EnquiryFour from "./tellusSteps/EnquiryFour";
import EnquiryFive from "./tellusSteps/EnquiryFive";
import Enquirysix from "./tellusSteps/Enquirysix";
import EnquirySeven from "./tellusSteps/EnquirySeven";
import EnquiryEight from "./tellusSteps/EnquiryEight";
import EnquiryNine from "./tellusSteps/EnquiryNine";
import EnquiryEleven from "./tellusSteps/EnquiryEleven";
import Enquiryloader from "./tellusSteps/Enquiryloader";
import EnquiryTen from "./tellusSteps/EnquiryTen";
import { useMutation } from "@tanstack/react-query";
import { postRequest } from "../services/apiMethods";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomerSetPassword from "./tellusSteps/CustomerSetPassword";
import CustomerEnterOtp from "./tellusSteps/CustomerEnterOtp";
import PropertyType from "./tellusSteps/PropertyType";

function TellUsMoreModal({ show, handleClose, selectedData, userDetail }) {
  const userToken = localStorage.getItem("token");
  const fcm_token = localStorage.getItem("fcm_token") || "";
  const deviceType = localStorage.getItem("deviceType") || "";
  const Navigate = useNavigate();
  const [anotherWay, setAnotherWay] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [loading, setLoading] = useState(false); // Create loading state
  const [apiLoading, setapiLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const initialValues = {
    name: userDetail?.name || "",
    email: userDetail?.email || "",
    role: "Customer",
    deviceType: deviceType,
    deviceToken: fcm_token,
    postCode: "",
    address: "",
    phoneNumber: userDetail?.phoneNumber || "",
    countryCode: userDetail?.countryCode || "",
    latitude: 0,
    longitude: 0,
    category: selectedData?.category || "",
    service: selectedData?.service || "",
    city: "",
    taskDescription: "",
    businessType: "",
    decisionType: "",
    needType: "",
    quotation: "",
    estimatedBudget: "",
    propertyType: "",
    password: "",
    confirmPassword: "",
    otp: ""
  };

  const getValidationSchema = () => {
    switch (activeStep) {
      case 0:
        return EnquiryThreeValidation;
      case 1:
        return propertyTypeValidation;
      case 2:
        return EnquiryFourValidation;
      case 3:
        return EnquiryFiveValidation;
      case 4:
        return EnquirysixValidation;
      case 5:
        return EnquirySevenValidation;
      case 6:
        return EnquiryEightValidation;
      case 7:
        return anotherWay ? EnquiryTenValidation : EnquiryNineValidation;
      case 8:
        return EnquiryElevenValidation;
      case 9:
        return customerPasswordSet;
      case 10:
        return customerOtpSet;


      default:
        return Yup.object(); // Fallback schema if needed
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
      setAnotherWay(false);
    } else {
      handleClose();
    }
  };

  const handleSwithCases = () => {
    setAnotherWay(!anotherWay);
  };

  const handleChangePage = () => {
    setActiveStep(activeStep + 1);
  };

  const { mutate } = useMutation({
    mutationFn: (data) => {
      setapiLoading(true)
      if (activeStep !== 9) {
        setLoading(true);
      }
      if (userToken) {
        return postRequest(`/lead/create`, data);
      } else {
        return postRequest("/auth/register", data);
      }
    },
    onSuccess: (data) => {
      setLoading(false);
      setapiLoading(false)
      // setTimeout(() => {
      if (userToken) {
        Navigate(`/enquiry-detail/${data?.data?.lead?._id}`);
      } else {
        if (activeStep == 9) {
          setActiveStep(activeStep + 1);
        } else {
          if (data?.data?.isOtpVerified) {
            const token = data?.data?.token;
            if (token) {
              localStorage.setItem("token", token);
              localStorage.setItem("role", "Customer");
              localStorage.setItem("isPasswordSet", data?.data?.isPasswordSet);
            }
            Navigate(`/enquiry-detail/${data?.data?.lead?._id}`);

            toast.success(data?.message || "Success!", {
              iconTheme: {
                primary: "#337FE0",
                secondary: "#FFFAEE",
              },
            });
          }
        }
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setLoading(false);
      setapiLoading(false)
    },
  });

  const handleSubmit = (value) => {
    console.log("AllVAlues ", value);
    if (userToken) {
      if (activeStep < 8) {
        setActiveStep(activeStep + 1);
      } else {
        let payload
        if (userToken) {
          const { deviceType, deviceToken, password, confirmPassword, otp, ...valueWithoutDeviceInfo } = value;
          payload = {
            ...valueWithoutDeviceInfo,
            decisionType: Number(value?.decisionType),
          };
        } else {
          payload = {
            ...value,
            decisionType: Number(value?.decisionType),
          };
        }
        mutate(payload);
      }
    } else {
      if (activeStep == 9) {
        let payload
        if (userToken) {
          const { deviceType, deviceToken, password, confirmPassword, otp, ...valueWithoutDeviceInfo } = value;
          payload = {
            ...valueWithoutDeviceInfo,
            decisionType: Number(value?.decisionType),
            isCompleted: true,
          };
        } else {
          payload = {
            ...value,
            isCompleted: true,
            decisionType: Number(value?.decisionType),
          };
        }
        mutate(payload);
      } else {
        if (activeStep < 10) {
          setActiveStep(activeStep + 1);
        } else {
          let payload
          if (userToken) {
            const { deviceType, deviceToken, password, confirmPassword, otp, ...valueWithoutDeviceInfo } = value;
            payload = {
              ...valueWithoutDeviceInfo,
              decisionType: Number(value?.decisionType),
              isOtpVerified: true,

            };
          } else {
            payload = {
              ...value,
              isOtpVerified: true,
              decisionType: Number(value?.decisionType),
            };
          }
          mutate(payload);
        }

      }

    }
  };

  return (
    <Modal size="md" show={show}>
      <Modal.Header
        onClick={() => setResetModal(true)}
        className={activeStep == 10 && !resetModal ? `` : "comn-btn-close"}
        closeButton
      >
        {activeStep == 10 && !resetModal &&
          <Modal.Title >

            Verify OTP

          </Modal.Title>}

      </Modal.Header>
      <Modal.Body>
        <div
          className="stepper-container"
          style={{ display: resetModal ? "" : "none" }}
        >
          <div className="quit-account-set">
            <h3>Are you sure that you want to leave?</h3>
            <p>
              We're asking a few questions so we can find you the right pros,
              and send you quotes fast and free!
            </p>
          </div>
          <div className="buttons d-flex justify-content-between mt-4 mb-2">
            <>
              <button
                className="theme-white-comm-btn"
                onClick={() => {
                  if (userToken) {
                    window.location.reload()
                  } else {
                    localStorage.clear()
                    window.location.reload()
                  }
                }
                }
                type="button"
              >
                Quit
              </button>
              <button
                className="theme-comm-btn"
                type="button"
                onClick={() => setResetModal(false)}
              >
                Continue
              </button>
            </>
          </div>
        </div>

        <div
          className="stepper-container"
          style={{ display: resetModal ? "none" : "" }}
        >
          <Formik
            initialValues={initialValues}
            validationSchema={getValidationSchema()}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, errors, touched, values }) => (
              <Form>
                <div className="stepper-content">
                  {loading ? (
                    <Enquiryloader
                      setFieldValue={setFieldValue}
                      errors={errors}
                      touched={touched}
                      values={values}
                    />
                  ) : (
                    <div>
                      {activeStep == 0 && (
                        <EnquiryThree
                          handleChangePage={handleChangePage}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}

                      {activeStep == 1 && (
                        <PropertyType
                          handleChangePage={handleChangePage}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}

                      {activeStep == 2 && (
                        <EnquiryFour
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}

                      {activeStep == 3 && (
                        <EnquiryFive
                          handleChangePage={handleChangePage}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}
                      {activeStep == 4 && (
                        <Enquirysix
                          handleChangePage={handleChangePage}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}
                      {activeStep == 5 && (
                        <EnquirySeven
                          handleSwithCases={handleSwithCases}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}
                      {activeStep == 6 && (
                        <EnquiryEight
                          handleSwithCases={handleSwithCases}
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}
                      {activeStep == 7 && (
                        <>
                          {anotherWay ? (
                            <EnquiryTen
                              handleSwithCases={handleSwithCases}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              values={values}
                            />
                          ) : (
                            <EnquiryNine
                              handleSwithCases={handleSwithCases}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              touched={touched}
                              values={values}
                            />
                          )}
                        </>
                      )}
                      {activeStep == 8 && (
                        <EnquiryEleven
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}

                      {activeStep == 9 && (
                        <CustomerSetPassword
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}

                      {activeStep == 10 && (
                        <CustomerEnterOtp
                          setFieldValue={setFieldValue}
                          errors={errors}
                          touched={touched}
                          values={values}
                        />
                      )}

                      <div className="buttons d-flex justify-content-between mt-4 mb-2">
                        <button
                          className="theme-white-comm-btn"
                          onClick={handleBack}
                          type="button"
                          disabled={loading}
                        >
                          Back
                        </button>
                        {userToken ?
                          <button className="theme-comm-btn add-new-width" type="submit">
                            {activeStep === 8 ? "Finish" : "Next"}
                          </button>
                          :
                          <button disabled={apiLoading} className="theme-comm-btn add-new-width" type="submit">
                            {activeStep === 10 ? "Finish" : "Next"}
                          </button>
                        }
                      </div>
                    </div>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default TellUsMoreModal;
